import type { CurationQueueSource } from '@avisoma/shared';

export const CURATION_SOURCE_LABELS: Record<CurationQueueSource, string> = {
  manual_flag: 'Flag',
  ai_scanner: 'AI',
  completeness: 'Completeness',
  user_mismatch: 'User',
  second_opinion: 'Second opinion',
  outlier: 'Outlier',
  low_certainty: 'Low certainty',
  cluster_page: 'Cluster page',
  page_edit: 'Page edit',
};
